export default __webpack_public_path__ + "static/media/530.29564de7.jpg";